export default "__VITE_ASSET__GNCnb4Yx__"